import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';

const { TextArea } = Input;

const RDTextArea = ({
  placeholder,
  textAreaStyles,
  handleChange,
  textAreaValue,
  autoSize,
  readOnly,
  textAreaDisabled,
}) => (
  <TextArea
    value={textAreaValue}
    onChange={handleChange}
    placeholder={placeholder}
    autoSize={autoSize}
    style={textAreaStyles}
    readOnly={readOnly}
    disabled={textAreaDisabled}
  />
);

RDTextArea.defaultProps = {
  autoSize: false,
  placeholder: '',
  textAreaStyles: {},
  textAreaValue: '',
  readOnly: false,
  textAreaDisabled: false,
  handleChange: () => {},
};

RDTextArea.propTypes = {
  /** Textarea placeholder */
  placeholder: PropTypes.string,
  /** Inline style applied to the textarea field */
  textAreaStyles: PropTypes.shape({}),
  /** The textarea content value */
  textAreaValue: PropTypes.string,
  /** Callback when user input */
  handleChange: PropTypes.func,
  /** Height autosize feature, can be set to true | false or an object { minRows: 2, maxRows: 6 } */
  autoSize: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      minRows: PropTypes.number,
      maxRows: PropTypes.number,
    }),
  ]),
  /** Whether the textarea is readonly */
  readOnly: PropTypes.bool,
  /** Whether the textarea is disabled */
  textAreaDisabled: PropTypes.bool,
};

export default RDTextArea;
